import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Notifications } from '@src/app/_models/notification/notification';
import { EnvironmentService } from '@src/app/_services/environment.service';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private readonly notificationsUrl: string;

    notificationsOld$: Observable<Notifications[] | undefined>;

    notificationsNew$: Observable<Notifications[] | undefined>;

    constructor(
        private readonly http: HttpClient,
        private readonly environmentService: EnvironmentService
    ) {
        this.notificationsUrl = this.environmentService.backendURL + '/api/notify';
    }

    allAsRead(userId: number): Observable<boolean> {
        const url = `${this.notificationsUrl}/allAsRead`;

        return this.http.put<boolean>(url, { user_id: userId }, httpOptions);
    }
}
